import { GetterTree } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AuctionState } from './AuctionState'
import { NotificationData } from './NotificationData'
import { PersonalData } from './PersonalData'
import { RepresentationData } from './RepresentationData'
import { StatementsData } from './StatementsData'
import { DocumentationsData } from './DocumentationsData'
import { VerificationData } from './VerificationData'

export const getters: GetterTree<AuctionState, RootState> = {
  resforNif (state: AuctionState): string {
    return state.resforNif
  },
  resforCode (state: AuctionState): string {
    return state.resforCode
  },
  lastWizardStep (state: AuctionState): number {
    return state.lastWizardStep
  },
  procesedAuctionA (state: AuctionState): boolean {
    return state.procesedAuctionA
  },
  notification (state: AuctionState): NotificationData {
    return state.notification
  },
  personalData (state: AuctionState): PersonalData {
    return state.personalData
  },
  representationData (state: AuctionState): RepresentationData {
    return state.representationData
  },
  procedureData (state: AuctionState): string[] {
    return state.procedureData
  },
  statementData (state: AuctionState): StatementsData {
    return state.statementsData
  },
  docOptionSelected (state: AuctionState): number {
    return state.docOptionSelected
  },
  documentationsData (state: AuctionState): DocumentationsData[] {
    return state.documentationsData
  },
  verificationData (state: AuctionState): VerificationData[] {
    return state.verificationData
  },
  fullStatus (state: AuctionState): AuctionState {
    return state
  },
  applicantNif (state: AuctionState): string {
    return state.personalData.nif
  }
}
